import { render, staticRenderFns } from "./ImelessTextarea.vue?vue&type=template&id=1f865c50&scoped=true&"
import script from "./ImelessTextarea.vue?vue&type=script&lang=ts&"
export * from "./ImelessTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./ImelessTextarea.vue?vue&type=style&index=0&id=1f865c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f865c50",
  null
  
)

export default component.exports